// Import model
import { GetGooglePlaceResponse } from '../models/GetGooglePlaceResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { GeoJsonPoint } from '../models/GeoJsonPoint';

// Import dependency serializers (for complex types)
import { GeoJsonPointSerializer } from './GeoJsonPointSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GetGooglePlaceResponse - handles JSON serialization and deserialization with type validation
 */
export class GetGooglePlaceResponseSerializer {
  /**
   * Deserializes a JSON string into a GetGooglePlaceResponse instance
   */
  static deserialize(json: string): GetGooglePlaceResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GetGooglePlaceResponse instance
   */
  static fromObject(obj: any): GetGooglePlaceResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GetGooglePlaceResponse');
    }


    const instance: GetGooglePlaceResponse = {
      formattedAddress: obj['formattedAddress'] as string | undefined,
      streetNumber: obj['streetNumber'] as string | undefined,
      street: obj['street'] as string | undefined,
      neighborhood: obj['neighborhood'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      county: obj['county'] as string | undefined,
      country: obj['country'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      postalCodeSuffix: obj['postalCodeSuffix'] as string | undefined,
      coordinates: obj['coordinates'] ? GeoJsonPointSerializer.fromObject(obj['coordinates']) : undefined as any,
      components: obj['components'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GetGooglePlaceResponse instances
   */
  static deserializeArray(json: string): GetGooglePlaceResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GetGooglePlaceResponse instance to a JSON string
   */
  static serialize(instance: GetGooglePlaceResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GetGooglePlaceResponse instance to a plain object
   */
  static toObject(instance: GetGooglePlaceResponse): any {
    return {
      'formattedAddress': instance.formattedAddress,
      'streetNumber': instance.streetNumber,
      'street': instance.street,
      'neighborhood': instance.neighborhood,
      'city': instance.city,
      'state': instance.state,
      'county': instance.county,
      'country': instance.country,
      'postalCode': instance.postalCode,
      'postalCodeSuffix': instance.postalCodeSuffix,
      'coordinates': instance.coordinates ? GeoJsonPointSerializer.toObject(instance.coordinates) : undefined,
      'components': instance.components,
    };
  }

  /**
   * Serializes an array of GetGooglePlaceResponse instances to a JSON string
   */
  static serializeArray(instances: GetGooglePlaceResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
